module.exports = __webpack_public_path__ + "static/img/resource-complete.3ee87049.png";